module.exports = __webpack_public_path__ + "static/media/NamrahHasan.d555407c.jpg";